// extracted by mini-css-extract-plugin
export default {"slider":"patientAppointments_slider__8pzOn"};